import type { SocialProvider } from '../api/userland'

const KEY = 'wils.social.register'

export type SocialPending = {
  provider: SocialProvider
  ticket: string
}

export function readSocialPending(): SocialPending | null {
  try {
    const raw = sessionStorage.getItem(KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as Partial<SocialPending>
    if (parsed.provider !== 'google' && parsed.provider !== 'telegram') return null
    if (!parsed.ticket) return null
    return { provider: parsed.provider, ticket: parsed.ticket }
  } catch {
    return null
  }
}

export function writeSocialPending(value: SocialPending): void {
  sessionStorage.setItem(KEY, JSON.stringify(value))
}

export function clearSocialPending(): void {
  sessionStorage.removeItem(KEY)
}
